"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var useFocusRef_1 = require("spry-react/utils/hooks/useFocusRef");
require("./errorDisplayList.less");
function ErrorDisplayList(props) {
    var visible = props.errors.length > 0;
    var errorItems = props.errors.map(function (e, index) { return React.createElement("li", { key: index }, e); });
    var htmlRef = useFocusRef_1.useFocusRef(props.focusRef);
    return (React.createElement("div", { className: "validation-summary " + (props.allValidationsAreWarnings ? 'validation-summary-warnings' : 'validation-summary-errors'), style: { display: visible ? 'block' : 'none' }, tabIndex: 0, ref: htmlRef },
        React.createElement("ul", { "aria-label": "Errors" }, errorItems)));
}
exports.ErrorDisplayList = ErrorDisplayList;
